export const toDacInstallationDate = (value: string): string | undefined => {
  const match = /^(\d{1,2})\.(\d{1,2})\.(\d{4})$/.exec(value);
  if (!match) {
    const isoMatch = /^(\d{4})-(\d{2})-(\d{2})T\d{2}:\d{2}:\d{2}(?:\.\d+)?Z$/.exec(value);
    const parsedDate = new Date(value);
    if (
      !isoMatch ||
      Number.isNaN(parsedDate.getTime()) ||
      parsedDate.getUTCFullYear() !== Number(isoMatch[1]) ||
      parsedDate.getUTCMonth() !== Number(isoMatch[2]) - 1 ||
      parsedDate.getUTCDate() !== Number(isoMatch[3])
    ) {
      return undefined;
    }

    return `${isoMatch[1]}-${isoMatch[2]}-${isoMatch[3]}T00:00:00Z`;
  }

  const day = Number(match[1]);
  const month = Number(match[2]);
  const year = Number(match[3]);
  const date = new Date(Date.UTC(year, month - 1, day));
  if (date.getUTCFullYear() !== year || date.getUTCMonth() !== month - 1 || date.getUTCDate() !== day) {
    return undefined;
  }

  return `${year.toString().padStart(4, '0')}-${month.toString().padStart(2, '0')}-${day
    .toString()
    .padStart(2, '0')}T00:00:00Z`;
};
